<template>
  <div class="equipment-management">
    <!-- 页面标题 -->
    <div class="page-header">
      <h2 class="page-title">预警管理</h2>
    </div>

    <!-- 搜索和操作区域 -->
    <div class="search-filter">
      <el-form :inline="true" :model="searchForm" size="small">
        <el-form-item label="告警设备">
          <el-input v-model="searchForm.device" placeholder="请输入设备名称" clearable style="width: 180px" />
        </el-form-item>
        <el-form-item label="告警类型">
          <el-select v-model="searchForm.type" placeholder="请选择类型" clearable style="width: 150px">
            <el-option label="温度异常" value="temperature" />
            <el-option label="压力异常" value="pressure" />
            <el-option label="电压异常" value="voltage" />
            <el-option label="离线告警" value="offline" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="searchWarnings">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" icon="el-icon-download" @click="handleExport">导出报表</el-button>
          <el-button type="info" icon="el-icon-message" @click="handleNotifySettings">通知设置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 预警列表表格 -->
    <div class="table-container">
      <el-table :data="warningList" style="width: 100%" border v-loading="loading" element-loading-background="rgba(26, 35, 50, 0.8)">
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="device" label="告警设备" min-width="150" align="center" />
        <el-table-column prop="typeLabel" label="告警类型" min-width="120" align="center">
          <template slot-scope="scope">
            <el-tag :type="getWarningTagType(scope.row.type)" size="small" effect="dark">
              {{ scope.row.typeLabel }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="time" label="告警时间" min-width="180" align="center" />
        <el-table-column prop="handler" label="处理人" min-width="120" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.handler || '待处理' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="handleTime" label="处理时间" min-width="180" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.handleTime || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button type="text" v-if="!scope.row.handler" @click="handleProcess(scope.row)">处理</el-button>
            <el-button type="text" v-else @click="viewDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 通知设置对话框 -->
    <el-dialog
      title="预警通知设置"
      :visible.sync="notifyDialogVisible"
      width="450px"
      append-to-body
      custom-class="dark-dialog">
      <el-form :model="notifyForm" label-width="120px">
        <el-form-item label="通知方式">
          <el-checkbox-group v-model="notifyForm.methods">
            <el-checkbox label="sms">短信通知</el-checkbox>
            <el-checkbox label="platform">平台消息</el-checkbox>
            <el-checkbox label="email">邮件通知</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="通知级别">
          <el-select v-model="notifyForm.level" placeholder="请选择通知级别" style="width: 100%">
            <el-option label="仅严重告警" value="critical" />
            <el-option label="重要及以上" value="important" />
            <el-option label="所有告警" value="all" />
          </el-select>
        </el-form-item>
        <el-form-item label="接收手机号" v-if="notifyForm.methods.includes('sms')">
          <el-input v-model="notifyForm.phone" placeholder="多个手机号用逗号隔开" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="notifyDialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="saveNotifySettings" size="small">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'EquipmentManagement',
  data() {
    return {
      loading: false,
      warningList: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchForm: {
        device: '',
        type: ''
      },
      notifyDialogVisible: false,
      notifyForm: {
        methods: ['platform'],
        level: 'important',
        phone: ''
      }
    };
  },
  mounted() {
    this.getWarningList();
  },
  methods: {
    getWarningList() {
      this.loading = true;
      setTimeout(() => {
        const mockData = [
          { id: 1, device: '1#冷水机组', type: 'temperature', typeLabel: '温度异常', time: '2024-03-20 10:00:00', handler: '张三', handleTime: '2024-03-20 10:30:00' },
          { id: 2, device: '2#冷却泵', type: 'pressure', typeLabel: '压力异常', time: '2024-03-20 11:15:00', handler: '', handleTime: '' },
          { id: 3, device: '3#空压机', type: 'offline', typeLabel: '离线告警', time: '2024-03-20 14:20:00', handler: '李四', handleTime: '2024-03-20 14:45:00' },
          { id: 4, device: '1#变压器', type: 'voltage', typeLabel: '电压异常', time: '2024-03-21 09:00:00', handler: '', handleTime: '' },
          { id: 5, device: '4#风机', type: 'temperature', typeLabel: '温度异常', time: '2024-03-21 13:10:00', handler: '王五', handleTime: '2024-03-21 13:50:00' },
          { id: 6, device: '2#冷水机组', type: 'pressure', typeLabel: '压力异常', time: '2024-03-22 08:30:00', handler: '', handleTime: '' },
          { id: 7, device: '5#水泵', type: 'offline', typeLabel: '离线告警', time: '2024-03-22 16:40:00', handler: '赵六', handleTime: '2024-03-22 17:00:00' }
        ];

        let filteredData = [...mockData];
        if (this.searchForm.device) {
          filteredData = filteredData.filter(item => item.device.includes(this.searchForm.device));
        }
        if (this.searchForm.type) {
          filteredData = filteredData.filter(item => item.type === this.searchForm.type);
        }

        this.total = filteredData.length;
        const start = (this.currentPage - 1) * this.pageSize;
        const end = start + this.pageSize;
        this.warningList = filteredData.slice(start, end);
        this.loading = false;
      }, 600);
    },
    searchWarnings() {
      this.currentPage = 1;
      this.getWarningList();
    },
    resetSearch() {
      this.searchForm = { device: '', type: '' };
      this.currentPage = 1;
      this.getWarningList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getWarningList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getWarningList();
    },
    getWarningTagType(type) {
      const map = {
        temperature: 'danger',
        pressure: 'warning',
        voltage: 'danger',
        offline: 'info'
      };
      return map[type] || 'primary';
    },
    handleExport() {
      this.$message({
        message: '正在生成预警报表，请稍候...',
        type: 'success'
      });
      // 模拟导出过程
      setTimeout(() => {
        this.$message.success('报表导出成功！');
      }, 1500);
    },
    handleNotifySettings() {
      this.notifyDialogVisible = true;
    },
    saveNotifySettings() {
      this.$message.success('通知设置已保存');
      this.notifyDialogVisible = false;
    },
    handleProcess(row) {
      this.$confirm(`确定开始处理设备 "${row.device}" 的告警吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info',
        customClass: 'dark-message-box'
      }).then(() => {
        this.$message.success('已接手处理');
        this.getWarningList();
      }).catch(() => {});
    },
    viewDetail(row) {
      this.$message.info(`查看设备 ${row.device} 的详细告警记录`);
    }
  }
};
</script>

<style scoped>
.equipment-management {
  padding: 0;
  background-color: #0a0e1a;
  min-height: 100%;
  width: 100%;
  color: #fff;
  box-sizing: border-box;
}

.page-header {
  padding: 20px;
  margin-bottom: 0;
  border-left: 4px solid #ff9800;
  background-color: #1a2332;
  border-bottom: 1px solid rgba(255, 152, 0, 0.1);
}

.page-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
}

.search-filter {
  background-color: #1a2332;
  padding: 15px 20px;
  margin: 0;
  border-bottom: 1px solid rgba(255, 152, 0, 0.1);
  text-align: left;
}

.search-filter .el-form-item {
  margin-bottom: 0;
  margin-right: 15px;
}

.table-container {
  background-color: #1a2332;
  padding: 0;
  margin: 0;
  border: none;
}

.pagination {
  padding: 15px 20px;
  display: flex;
  justify-content: flex-end;
}

/* 覆盖Element UI样式以适应深色主题 */
::v-deep .el-form-item__label {
  color: #b0c4de;
}

::v-deep .el-input__inner {
  background-color: #0d141e;
  border-color: #2c3e50;
  color: #fff;
}

::v-deep .el-input__inner:focus {
  border-color: #ff9800;
}

::v-deep .el-table {
  background-color: transparent;
  color: #b0c4de;
  border: 1px solid #2c3e50;
}

::v-deep .el-table th {
  background-color: #131924 !important;
  color: #fff;
  border-bottom: 1px solid #2c3e50;
  border-right: 1px solid #2c3e50;
}

::v-deep .el-table td {
  background-color: transparent !important;
  border-bottom: 1px solid #2c3e50;
  border-right: 1px solid #2c3e50;
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: rgba(255, 152, 0, 0.1) !important;
}

::v-deep .el-pagination {
  color: #b0c4de;
}

::v-deep .el-pagination .el-select .el-input .el-input__inner {
  background-color: #0d141e;
  border-color: #2c3e50;
}

::v-deep .el-pager li {
  background-color: transparent;
  color: #b0c4de;
}

::v-deep .el-pager li.active {
  color: #ff9800;
}

/* 弹窗样式 */
::v-deep .dark-dialog {
  background-color: #1a2332;
  border: 1px solid #2c3e50;
}

::v-deep .dark-dialog .el-dialog__title {
  color: #fff;
}

::v-deep .dark-dialog .el-dialog__body {
  color: #b0c4de;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #b0c4de;
}

::v-deep .el-message-box.dark-message-box {
  background-color: #1a2332;
  border: 1px solid #2c3e50;
}

::v-deep .dark-message-box .el-message-box__title,
::v-deep .dark-message-box .el-message-box__content {
  color: #fff;
}

::v-deep .el-checkbox {
  color: #b0c4de;
}
</style>



// WEBPACK FOOTER //
// src/views/equipment.vue